import { Box, Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import DatePicker from "../../../components/common/DatePicker";
import Subheading from "../../../components/common/Subheading";
import Subtitle from "../../../components/common/Subtitle";
import PlatformSelection from "./PlatformSelection";

/**
 * GeocoderForm component for configuring geocoder task parameters.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.formData - Current form data.
 * @param {Function} props.onFormChange - Callback function to notify parent about state changes.
 *
 * @returns {JSX.Element} - The JSX element for the geocoder form.
 */
function GeocoderForm({ formData, onFormChange }) {
  const handleDateChange = (field) => (val) => {
    onFormChange({ ...formData, [field]: val });
  };

  const handlePlatformChange = (selectedPlatforms) => {
    onFormChange({ ...formData, selectedPlatforms: selectedPlatforms });
  };

  return (
    <Grid container direction="column" wrap="nowrap" spacing={4} p={{ xs: 2, md: 3 }} mx={{ xs: 0, md: "10%" }}>
      {/* Platform Selection Section */}
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Subheading text="Table Selection" sx={{ mb: 3 }} />
        <PlatformSelection selectedPlatforms={formData.selectedPlatforms} onPlatformChange={handlePlatformChange} />
      </Paper>

      {/* Date Range Section */}
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Subheading text="Date Range" sx={{ mb: 3 }} />
        <Grid container spacing={3} justifyContent="center">
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              flexDirection="column"
              borderRadius="15px"
              p={1}
              sx={{ backgroundColor: "#121212", display: "flex", justifyContent: "center", textAlign: "center" }}
            >
              <Subtitle text="Start Date" sx={{ fontSize: "1.15rem", py: 1 }} />
              <DatePicker currentVal={formData.startDate} handleVal={handleDateChange("startDate")} />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: "center" }}>
            <Box
              flexDirection="column"
              borderRadius="15px"
              p={1}
              sx={{ backgroundColor: "#121212", display: "flex", justifyContent: "center" }}
            >
              <Subtitle text="End Date" sx={{ fontSize: "1.15rem", py: 1 }} />
              <DatePicker currentVal={formData.endDate} handleVal={handleDateChange("endDate")} />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}

export default GeocoderForm;
